import * as z from 'zod'
import { CarEquipmentTypeEnum } from '~/shared/config/enums'
import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributesSchema = z.object({
  title: z.string(),
  type: z.nativeEnum(CarEquipmentTypeEnum),
  equipmentId: z.string(),
  value: z.boolean(),
})

const schema = z
  .object({
    createdAt: dateSchema,
    updatedAt: dateSchema,
  })
  .merge(attributesSchema)

export type InspectionEquipmentAttributes = z.infer<typeof schema>

export class InspectionEquipment extends ApiModel<
  typeof schema,
  InspectionEquipmentAttributes
> {
  static jsonApiType = 'inspection-equipments'

  static schema = schema
}
